import React from "react"
import Link from "./Link"
import logo from "../img/teamspective-logo-regular-color.svg"
import logoMobile from "../img/teamspective-logo-t-small-color.svg"
import hamburger from "../img/hamburger.svg"
import Icon from "./Icon"
import { classNames } from "./utils"

const Navbar = ({ navigationItems }) => {
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = React.useState(false)
  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : ""

  return (
    <div className="nav-outer">
      <nav
        className={hamburgerMenuOpen ? "menu-open" : undefined}
        role="navigation"
        aria-label="main-navigation"
      >
        <img
          className="hamburger-menu"
          src={hamburger}
          alt="Menu icon"
          role="button"
          onClick={() => setHamburgerMenuOpen((v) => !v)}
        />
        <Link to="/" title="Logo" className="logo">
          <img
            src={logo}
            className="header-logo"
            alt="Teamspective"
            style={{ width: "200px" }}
          />
          <div style={{ padding: 8 }}>
            <img
              src={logoMobile}
              className="header-logo-mobile"
              alt="Teamspective"
              style={{ width: "36px" }}
            />
          </div>
        </Link>
        <div className="navigation-items">
          {navigationItems.map(({ title, path, children }) => (
            <div
              className={classNames(
                "navbar-item",
                currentPath.startsWith(path) ||
                  (children &&
                    children.some(({ path }) => currentPath.startsWith(path)))
                  ? "navbar-item-active"
                  : null
              )}
              key={path}
            >
              <Link to={path}>
                {title} {children && <span className="caret">⌄</span>}
              </Link>
              {children && (
                <div className="navbar-subitems" key={path}>
                  {children.map(({ title, description, path, icon }) => (
                    <Link className="navbar-subitem" to={path} key={path}>
                      <Icon icon={icon} />{" "}
                      <div>
                        <div className="title">{title}</div>
                        <p>{description}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          <div className={classNames("navbar-item", "mobile-only")} key="login">
            <Link to="https://app.teamspective.com/login">
              <b>Log In</b>
            </Link>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Link
            className="desktop-only"
            to="https://app.teamspective.com/login"
          >
            Log In
          </Link>
          <Link className="button" to="/book-a-demo">
            Book a demo
          </Link>
        </div>
      </nav>
    </div>
  )
}

export default Navbar
